// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Retomada_DesfazerContatoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** Resposta de /retomada/desfazer_contato (chamado 2026-0052). */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Retomada_DesfazerContatoResponseDados {
desfeito: boolean
}

export type Retomada_DesfazerContatoResponse = ApiResponse<Retomada_DesfazerContatoResponseDados>;

registerResponseContract('Retomada_DesfazerContatoResponse', {
  desfeito: { type: 'boolean', required: true },
})
